<template>
  <div
    :class="[`nice-select ${className}`, { open }] "
    tabindex="0"
    @click.prevent="toggleOpen"
    role="button"
  >
    <span class="current">{{ current?.text || placeholder }}</span>
    <ul class="list" role="menubar" @click.prevent="$event.stopPropagation()">
      <li
        :class="[`option`, { 'selected focus': item.value === current.value }]"
        v-for="(item, index) in options"
        :key="`option-${index}`"
        @click.prevent="currentHandler(item, index)"
        role="menuitem"
      >
        {{ item.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NiceSelect",
  props: {
    options: {
      type: Array,
      required: true,
    },
    defaultCurrent: {
      type: Number,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Select an option", // Default placeholder
    },
    className: {
      type: String,
      default: "", // Default className
    },
    name: {
      type: String,
      default: "", // Default name
    },
  },
  data() {
    return {
      open: false,
      current: this.options[this.defaultCurrent] || {}, // Initialize current based on defaultCurrent
    };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open; // Toggle open state
    },
    onClose() {
      this.open = false; // Close the select
    },
    currentHandler(item, index) {
      this.current = this.options[index]; // Set the current option
      this.$emit("onChange", item); // Emit the onChange event
      this.onClose(); // Close the select after selecting
    },
  },
};
</script>

<style scoped>
/* Add styles here if needed */
</style>
